import React, { Component, Fragment } from 'react'
import { graphql, compose } from 'react-apollo'
import styled from 'styled-components'

import { ChipSelector, DefaultTextArea, DefaultInput, Dropdown, MultiSelect } from '../elements'
import { PopupMessage } from '../components'
import { GeneralFunctions } from '../helper'
import { BusinessQuery, GuarantorQuery } from '../queries'
import Loader from '../../common/Loader'
import UpdateAnswer from '../mutations/UpdateAnswer'
import CreateAffiliate from '../mutations/CreateAffiliate'
import DeleteAffiliate from '../mutations/DeleteAffiliate'
import UpdateAffiliateName from '../mutations/UpdateAffiliateName'
import AffiliateCard from './AffiliateCard'

const AFFILIATES_QUESTION_NUMBER = 316
const revenueQuestion = 1100
const revenueParentQuestion = 1101
const revenueAmount1 = 1102
const revenueAmount2 = 1103
const MULTI_COUNTRY = 509

const QuestionWrapper = styled.div`
  .indent {
    margin-left: 40px;
  }
  .cursor-pointer {
    cursor: pointer;
  }
`

const HelperSmall = styled.small`
  .add-space-left {
    margin-left: 10px
  }
`

class QuestionType extends Component {
  constructor(props) {
    super(props)
    const { rid, number } = props.question
    this.answer = props.answers.find(
      answer => Number(answer.questionId) === rid
    )
    this.state = {
      boolean: [
        { active: false, text: 'Yes', icon: 'icon-circle' },
        { active: false, text: 'No', icon: 'icon-circle' }
      ],
      multipleOptions: [],
      validations: {
        textarea: false,
        count: false
      },
      errorMessage: {
        text: "Please enter a valid description",
        number: "Please enter a valid number",
        answer: "Please enter an answer",
        date: "Please enter a valid date"
      },
      answered: Boolean(this.answer),
      answer: this.answer,
      showError: false,
      messageError: '',
      helpText: '',
      titleHelper: null,
      showModal: false,
      createActive: false,
      multipleOptionNumbers: [230, 702, 705, 1002],
      renderQuestionShouldAnswer: false,
      isShouldAnswered: this.answer ? [null, ''].includes(this.answer?.value) : true,
      savedAnswer: null,
      questionsAmount: [700, 602, 1102, 1103],
      questionShouldNotBeZero: [700],
      questionShouldTruncate: [706].includes(number),
      loadingAffiliatesSection: false,
    }
  }
  componentWillMount() {
    const { answer } = this.state
    const { question } = this.props
    const { format } = question

    if (answer && format === 'Answer::Boolean') {
      const value = answer?.value

      if (value) {
        const index = value.toString() === 'true' ? 0 : 1
        let { boolean } = this.state

        boolean[index].active = true
        this.setState({ boolean })
      }
    }
    if (format === 'Answer::Enumerate') {
      this.renderAnswers(question)
    }
  }
  componentWillReceiveProps({ answers, question: { rid } }) {
    const answer = answers.find(({ questionId }) => Number(questionId) === rid)

    this.setState({ answer })
  }
  get questionTitle() {
    const {
      props: { question: { description, number } },
      titlePerQuestion
    } = this

    return titlePerQuestion(number) || description
  }
  resolveOutput = values => {
    this.runMutationAnswer(values.join(','))
    this.setState({ answered: true })
    this.checkInputValues()
  }
  placeholderMultiselect = () => {
    const { questionNumber } = this

    switch (questionNumber) {
      case MULTI_COUNTRY:
        return `Search countries`
      default:
        return `Search for option`
    }
  }
  titlePerQuestion = number => {
    const {
      props: { answers, questions }
    } = this

    switch (number) {
      case revenueAmount1:
      case revenueAmount2:
        const answerParent = answers.find(({ questionNumber }) => questionNumber === revenueParentQuestion)?.value || ''
        const [{ selectOptions = [] }] = questions?.find(({ number }) => number === revenueQuestion)?.children || [{}]
        const [label] = selectOptions.find(([, value]) => value === answerParent) || ['']
        const revenueYear = number === revenueAmount1 ? 2019 : 2020

        return `Revenue in ${label.slice(0,2)} ${revenueYear}`
      default:
        return
    }
  }
  finalValue = value => {
    const { cleanNumberCurrency } = GeneralFunctions
    const { question: { number } } = this.props
    const { questionsAmount } = this.state
    let finalValue = value

    if (questionsAmount.includes(number)) {
      finalValue = cleanNumberCurrency(value)
    }

    return finalValue
  }
  get isAffiliateQuestion() {
    return this.props.question.number === AFFILIATES_QUESTION_NUMBER
  }
  get shouldRenderAffiliatesSection() {
    return (
      this.isAffiliateQuestion &&
      (this.props.entity.affiliates?.length > 0 ||
        this.loadingAffiliatesSection)
    )
  }
  get loadingAffiliatesSection() {
    return this.state.loadingAffiliatesSection
  }
  set loadingAffiliatesSection(value) {
    this.setState({ loadingAffiliatesSection: value })
  }
  runMutationAnswer = value => {
    this.updateAnswer(value)

    if (!this.isAffiliateQuestion) return
    if (value === false.toString()) return this.deleteAllAffiliates()
    if (this.props.entity.affiliates.length === 0) this.createAffiliate()
  }
  createAffiliate = () => { 
    this.loadingAffiliatesSection = true

    this.props
      .createAffiliateMutation({
        variables: { input: { guarantorId: this.props.entity.rid } },
      })
      .finally(() => (this.loadingAffiliatesSection = false))
  }
  deleteAffiliate = (affiliateId, preventLoader=false) => {
    if (!preventLoader) this.loadingAffiliatesSection = true

    return this.props
      .deleteAffiliateMutation({
        variables: {
          input: {
            model: 'business',
            rid: affiliateId,
          },
        },
      })
      .finally(() => {
        if (!preventLoader) this.loadingAffiliatesSection = false
      })
  }
  deleteAllAffiliates = () => { 
    this.loadingAffiliatesSection = true

    Promise.all(
      this.props.entity.affiliates.map((affiliate) =>
        this.deleteAffiliate(affiliate.rid, true)
      )
    ).finally(() => (this.loadingAffiliatesSection = false))
  }
  handleAffiliateChange = ({ name, id }) => { 
    this.loadingAffiliatesSection = true

    this.props
      .updateAffiliateNameMutation({
        variables: {
          input: {
            id: id.toString(),
            value: name,
            model: 'business',
            attribute: 'name',
          },
        },
      })
      .finally(() => (this.loadingAffiliatesSection = false))
  }
  updateAnswer = async value => {
    const {
      props: { question, entity, updateAnswerMutation }
    } = this
    let { answer = {} }= this.state

    answer.value = value
    this.setState({ answer })
    const input = {
      questionId: question.rid,
      answerableId: entity.rid,
      answerableType: entity.type,
      type: question.format,
      value: String(value),
      answerId: answer?.rid
    }

    try {
      await updateAnswerMutation({
        variables: { input },
        refetchQueries: [{
          query: entity.type === 'Business' ? BusinessQuery : GuarantorQuery,
          variables: { entityId: entity.rid },
        }]
      })
    } catch (err) {
      console.log(err)
    }
  }
  onToggleDetails = () => {
    const { showModal } = this.state

    this.setState({ showModal: !showModal })
  };
  checkInputValues = () => {
    const { checkInputValues } = this.props

    if (checkInputValues) {
      checkInputValues()
    }
  };
  getQuestionResponse = val => {
    const { getQuestionResponse, question: { number } } = this.props

    if (getQuestionResponse) {
      getQuestionResponse(val, number)
    }
  };
  removeErrorOnBlur = ({ target: { id }}) => {
    let { validations } = this.state

    validations[id] = false

    this.setState({ validations })
    this.checkInputValues()
  };
  onKeyup = e => {
    this.removeErrorOnBlur(e)
  }
  validateToSendData = ({ target }, valid) => {
    const { value, id } = target
    const finalValue = this.finalValue(value)

    if (valid) {
      this.runMutationAnswer(finalValue)
      this.setState({ answered: true })
    } else {
      let { validations } = this.state

      validations[id] = true
      this.setState({ validations })
    }
    this.checkInputValues()
  };
  optionSelectedEnumerate = (state, name, index, id) => {
    const { question } = this.props
    let { multipleOptionNumbers, multipleOptions } = this.state

    if (!multipleOptionNumbers.includes(question.number)) {
      if (!state) {
        multipleOptions.forEach(function(selector) {
          selector.active = false
        })
        multipleOptions[index].active = true
      }
    } else {
      multipleOptions[index].active = !state
    }

    const arrayValues = this.state.multipleOptions
      .filter(o => o.active)
      .map(n => n.value)
      .toString()
    this.runMutationAnswer(arrayValues)

    this.setState({ multipleOptions, answered: true })
    this.checkInputValues()
  };
  optionSelectedDropdown = (state, name) => {
    if (!state) {
      const { selectOptions } = this.props.question
      const [_text, indexOpt] = selectOptions.find(o => o[0] === name)
      this.runMutationAnswer(indexOpt)
    }

    this.setState({ answered: true })
    this.checkInputValues()
  };
  messageErrorBoolean = (requiredAnswer, answer) => {
    const { question: { number } } = this.props

    switch (number) {
      case 800:
      case 900:
      case 901:
      case 1000:
        return `If you answer "${answer}", the loan will not be approved. You will not be able to complete your loan application.`
      default:
        return `This answer must be a ${requiredAnswer === 'true' ? 'Yes' : 'No'}.`
    }
  }
  optionSelected = (state, name, index) => {
    const { requiredAnswer } = this.props.question
    if (!state) {
      let { boolean } = this.state
      boolean.forEach(selector => {
        selector.active = false
      })
      boolean[index].active = true
      this.setState({ boolean, answered: true })
    }
    let { showError, messageError } = this.state
    const booleanOption = name === 'Yes'
    if ([booleanOption.toString(), null].includes(requiredAnswer)) {
      this.runMutationAnswer(booleanOption.toString())
      showError = false
      messageError = ''
    } else {
      showError = true
      messageError = this.messageErrorBoolean(requiredAnswer, name)
    }
    this.setState({ showError, messageError })
    this.checkInputValues()
    this.getQuestionResponse(booleanOption)
  };
  renderAnswers = question => {
    const {
      state: { multipleOptionNumbers, answer }
    } = this
    const { rid, number, selectOptions } = question
    const value = answer?.value || ''
    const allOptions = []
    const icon = `icon-${multipleOptionNumbers.includes(number) ? 'square' : 'circle'}`

    selectOptions.forEach(option => {
      const [text, optionValue] = option
      const hash = {
        active: value.includes(optionValue),
        text,
        icon,
        value: optionValue,
        id: rid
      }
      allOptions.push(hash)
    })

    this.setState({ multipleOptions: allOptions })
  };
  componentDidMount() {
    if (this.title) {
      const [spanInfo] = this.title.querySelectorAll('span')
      if (!spanInfo) {
        return
      }
      const { helper, title } = spanInfo.dataset
      if (title) {
        this.setState({ helpText: title })
      }
      if (Boolean(helper) && helper !== 'null') {
        this.setState({ titleHelper: helper })
      }
    }
  }
  checkDropdownSelection = selection => {
    this.runMutationAnswer(selection)
    this.setState({ answered: true })
    this.checkInputValues()
  };
  helperText() {
    const {
      questionTitle,
      state: { helpText, titleHelper, showModal },
      props: { question }
    } = this

    return (
      <div className={`${helpText !== '' ? 'add-space-top' : ''} relative`}>
        <label
          className={`${helpText !== '' ? 'inline-box p-remove-margin' : ''}`}
          ref={el => this.title = el}
          dangerouslySetInnerHTML={{
            __html: questionTitle
          }}
        />
        {helpText !== '' && (
          <>
            {Boolean(!titleHelper) && <br />}
            <HelperSmall>
              <a
                className={`${
                  titleHelper
                    ? 'add-space-left text-color-light-gray'
                    : 'text-color-blue'
                } cursor-pointer`}
                onClick={this.onToggleDetails}
              >
                {titleHelper || 'Explain this.'}
              </a>
            </HelperSmall>
            {showModal && (
              <PopupMessage
                alignText="left"
                closeAction={this.onToggleDetails}
              >
                <h2
                  dangerouslySetInnerHTML={{
                    __html: question.description
                  }}
                />
                <hr />
                <div dangerouslySetInnerHTML={{ __html: helpText }} />
              </PopupMessage>
            )}
          </>
        )}
      </div>
    )
  }
  runAnsweredQuestion = (actionFunction, calculateVal) => {
    const { question: { number } } = this.props
    const { savedAnswer, questionShouldNotBeZero } = this.state

    let answer = String(savedAnswer)
    if (questionShouldNotBeZero.includes(number)) {
      answer = savedAnswer <= 0 ? '' : answer
    }

    this.setState({ isShouldAnswered: false })
    actionFunction(String(calculateVal))
    this.runMutationAnswer(answer)
  }
  renderChildQuestions = (childQuestions, commonPropsQuestion) => {
    if (childQuestions.length > 0) {
      return (
        <div className="indent">
          {childQuestions.map((q, i) => (
            <QuestionType
              key={`noChildren${i}`}
              ref={q.rid}
              question={q}
              {...commonPropsQuestion}
            />
          ))}
        </div>
      )
    }
  }
  returnQuestionFormat = () => {
    const {
      boolean,
      showError,
      messageError,
      answer,
      validations,
      multipleOptions,
      questionsAmount,
      errorMessage,
      questionShouldTruncate
    } = this.state
    const {
      question: {
        format,
        children,
        number,
        placeholder,
        rid,
        selectOptions
      },
      expandDropdown,
      entity,
      answers,
      bigStyle,
      disabled,
      updateAnswerMutation,
      questions
    } = this.props

    const commonProps = {
      onClick: this.removeErrorOnBlur,
      onBlur: this.validateToSendData,
      onKeyUp: this.onKeyup,
      disabled
    }

    const commonPropsQuestion = {
      checkInputValues: this.checkInputValues,
      entity,
      answers,
      disabled,
      updateAnswerMutation,
      questions
    }

    switch (format) {
      case 'Answer::Boolean':
        const getAnswer = type => (
          (children || []).filter(({parentAnswer }) => parentAnswer === type)
        )

        const yesChildren = getAnswer('true')
        const noChildren = getAnswer('false')

        return (
          <>
            <form>
              {this.helperText()}
              <br />
              {boolean.map((d, i) => (
                <ChipSelector
                  icon={d.icon}
                  text={d.text}
                  active={d.active}
                  key={`${number}${i}`}
                  accessId={`${number}${i}`}
                  data_id={i}
                  bigStyle={bigStyle}
                  onClick={this.optionSelected}
                  disabled={disabled}
                />
              ))}
              {showError && (
                <div>
                  <small className="text-color-red">{messageError}</small>
                </div>
              )}
            </form>
            {boolean.find(e => e.text === 'Yes').active && (
              <div className="indent">
                {this.renderChildQuestions(yesChildren, commonPropsQuestion)}
              </div>
            )}
            {boolean.find(e => e.text === 'No').active && (
              <div className="indent">
                {this.renderChildQuestions(noChildren, commonPropsQuestion)}
              </div>
            )}
          </>
        )
      case 'Answer::Text':
        return (
          <form>
            {this.helperText()}
            <DefaultTextArea
              value={answer ? answer.value : ''}
              validationType="default"
              id="textarea"
              placeholder={placeholder}
              error={validations.textarea}
              errorMessage={errorMessage.text}
              truncate={questionShouldTruncate}
              {...commonProps}
            />
          </form>
        )
      case 'Answer::Count':
        return (
          <form>
            {this.helperText()}
            <DefaultInput
              widthSize={250}
              value={answer ? answer.value : ''}
              validationType="default"
              cleave={{
                numeral: true,
                numeralPositiveOnly: true,
                delimiter: ''
              }}
              id={`${rid}`}
              dataAttribute="number"
              error={validations.count}
              errorMessage={errorMessage.number}
              {...commonProps}
            />
          </form>
        )
      case 'Answer::Decimal':
        const cleaveCurrency = questionsAmount.includes(number)
        let cleaveOptions = {
          numeral: true,
          numeralPositiveOnly: true,
          delimiter: ''
        }

        if (cleaveCurrency) {
          cleaveOptions = {
            numeral: true,
            numeralThousandsGroupStyle: 'thousand',
            prefix: '$ '
          }
        }

        return (
          <form>
            {this.helperText()}
            <DefaultInput
              widthSize={250}
              type="text"
              value={answer ? answer.value : ''}
              validationType="default"
              cleave={cleaveOptions}
              id="count"
              dataAttribute="count"
              error={validations.count}
              errorMessage={errorMessage.number}
              {...commonProps}
              cleaveCurrency={cleaveCurrency}
            />
          </form>
        )
      case 'Answer::String':
        return (
          <form>
            {this.helperText()}
            <DefaultInput
              value={answer ? answer.value : ''}
              validationType="default"
              id="count"
              dataAttribute="count"
              error={validations.count}
              errorMessage={errorMessage.answer}
              {...commonProps}
            />
          </form>
        )
      case 'Answer::Date':
        return (
          <form>
            {this.helperText()}
            <DefaultInput
              widthSize={110}
              value={answer ? answer.value : ''}
              validationType="full_date"
              placeholder="MM/DD/YYYY"
              cleave={{ date: true, datePattern: ['m', 'd', 'Y'] }}
              id="count"
              dataAttribute="count"
              format="date"
              error={validations.count}
              errorMessage={errorMessage.date}
              {...commonProps}
            />
          </form>
        )
      case 'Answer::Enumerate':
        return (
          <>
            <form>
              {this.helperText()}
              <br />
              {multipleOptions.map((d, i) => (
                <div key={`${number}${i}`}>
                  <ChipSelector
                    icon={d.icon}
                    text={d.text}
                    active={d.active}
                    bigStyle={bigStyle}
                    data_id={i}
                    accessId={`${number}${i}`}
                    db_id={d.id}
                    onClick={this.optionSelectedEnumerate}
                    disabled={disabled}
                  />
                </div>
              ))}
            </form>
            {multipleOptions.filter(({ active }) => active).length > 0 &&
              this.renderChildQuestions(children, commonPropsQuestion)
            }
          </>
        )
      case 'Answer::Dropdown':
        return (
          <form>
            {expandDropdown ?
              selectOptions.map((o, i) => (
                <Fragment key={`${number}${i}`}>
                  <ChipSelector
                    text={o[0]}
                    active={answer ? answer.value === o[1] : false}
                    fixedSize
                    accessId={`${number}${i}`}
                    data_id={i}
                    bigStyle={bigStyle}
                    onClick={this.optionSelectedDropdown}
                    disabled={disabled}
                  />
                  <br />
                </Fragment>
              ))
              : (
                <>
                  {this.helperText()}
                  <Dropdown
                    noPadding
                    id={`question_dropdown_${number}`}
                    defaultWith
                    value={answer ? answer.value : null}
                    options={selectOptions}
                    onChange={this.checkDropdownSelection}
                    disabled={disabled}
                  />
                </>
              )}
          </form>
        )
      case 'Answer::Array':
        return (
          <>
            <form>
              {this.helperText()}
              <MultiSelect
                id={`${number}-multiselect`}
                options={selectOptions}
                placeholder={this.placeholderMultiselect()}
                resolveOutput={this.resolveOutput}
                value={answer ? answer.value : ''}
                width='350px'
                strictFilter
              />
            </form>
          </>
        )
      default:
        null
    }
  }
  renderAffilliates = () => {
    if (this.loadingAffiliatesSection)
      return (
        <div style={{ width: '22%' }}>
          <Loader number={4} />
        </div>
      )

    return (
      <div className="indent">
        <label style={{ cursor: 'default' }}>
          Provide the names of all businesses you own:
        </label>
        <ul style={{ margin: 0 }}>
          {this.props.entity.affiliates.map(({ name, rid }, index) => (
            <li key={rid} style={{ listStyle: 'none' }}>
              <AffiliateCard
                id={rid}
                value={name}
                deletable={index > 0}
                onDelete={() => this.deleteAffiliate(rid)}
                handleChange={this.handleAffiliateChange}
              />
            </li>
          ))}
        </ul>
        <small>
          <a
            className="text-color-blue cursor-pointer"
            onClick={this.createAffiliate}
          >
            Add another business
          </a>
        </small>
      </div>
    )
  }
  render() {
    return (
      <QuestionWrapper>
        {this.returnQuestionFormat()}
        {this.shouldRenderAffiliatesSection && this.renderAffilliates()}
      </QuestionWrapper>
    )
  }
}

export { QuestionType }

export default compose(
  graphql(UpdateAnswer, { name: 'updateAnswerMutation' }),
  graphql(CreateAffiliate, { name: 'createAffiliateMutation' }),
  graphql(DeleteAffiliate, { name: 'deleteAffiliateMutation' }),
  graphql(UpdateAffiliateName, { name: 'updateAffiliateNameMutation' })
)(QuestionType)
